import React from 'react';
import { connect } from 'react-redux';
import { readCookie } from '../../common/Cookie';
import properties from '../../../modules/ajio-util/properties';
import { getIconStyles } from '../../../utils/common';

class CartComponent extends React.Component {
  render() {
    let showCartPopup = this.props.showCart;
    let linkClick = this.props.linkClick;
    let { cartCount: cartCounter = 0 } = this.props.counter;
    let cartCount = cartCounter;
    let {
      metaData: {
        sis = false,
        // textColor = "#FFF",
        current: { headerIconColor, buttonPatchColor } = {}
      } = {}
    } = this.props;
    /**
     * Browser specific code
     */
    let cookie;
    try {
      cookie = readCookie('nq');
    } catch (error) {
      console.log(`Failed to read cookie : ${error}`);
    }

    /**
     * Browser specific code
     */

    if (cookie) {
      let cookieList = cookie.split(':');
      if (cookieList.length) {
        cartCount = cookieList[0].split('=')[1];
      }
    }
    const iconStyles = getIconStyles({
      headerIconColor,
      buttonPatchColor
    });
    return (
      <a
        href={`${properties.getProperty('parentUrl')}/cart`}
        onClick={() => {
          linkClick('/cart', 'Bag', 'BagClick');
        }}
        className="cart-pos"
      >
        <div className={`ic-cart ${cartCount > 0 ? 'count' : ''}`} style={iconStyles}>
          {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
        </div>
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    showCart: state.popup.showCartPopup,
    counter: state.counter,
    metaData: state.metaData
  };
};

export default CartComponent = connect(mapStateToProps, null)(CartComponent);
